import ReduxProtectedGenericTable from './redux-protected-generic-table';

export default ReduxProtectedGenericTable;